<div class="tabbable__body rounded-top-right no-margin">
  <h3>
    Här kan du administrera omvandlingsnyckel för bruttokontakter
  </h3>

  <div #stickyHeader>
    <div class="flex__container align-items--left">
      <div class="input__container">
        <label for="factor">Omvandlingsnyckel</label>
        <input
          type="number"
          inputId="gross-rating-factor"
          name="grossRatingFactor"
          step="0.001"
          [(ngModel)]="grossRatingFactor"
        />
      </div>
      <div>
        <button
          class="button primary button margin-left--2x"
          [disabled]="disableSaveButton()"
          (click)="save()"
        >
          Spara
        </button>

        @if (show.hasHistory) {
          @if (!show.history) {
            <button class="button primary" (click)="openCard()">
              Historik
            </button>
          } @else {
            <button class="button primary" (click)="closeCard()">
              Stäng historik
            </button>
          }
        }
      </div>
    </div>
  </div>

  @if (show.history) {
    <h3>Historik</h3>
    <app-woo-table [data]="historyGrossRatingData" [sortable]="false">
      <woo-table-column header="Omvandlingsnyckel (tidigare värde -> nytt värde) " name="grossRatingFactor"></woo-table-column>
      <woo-table-column header="Uppdaterad" name="updatedAt">
        <ng-template let-cell>
          <span>{{ cell.value | date: 'yyyy-MM-dd' }}</span>
        </ng-template>
      </woo-table-column>
      <woo-table-column header="Användare" name="updater"></woo-table-column>
    </app-woo-table>
  }
</div>
